import * as yup from 'yup'

export const schema = yup.object().shape({
  justification: yup.string().required(),
})

export default schema
